import React, { Component } from 'react';
import styles from './Footer.scss';
import CodeResetButton from './CodeResetButton';
import RunCodeButton from './RunCodeButton';

//hosts the button to run the code
// dispatches action which submits the code via API

class Footer extends Component {
  render() {
    return (
      <div
        className={styles['c-footer']}
        style={{
          backgroundColor: this.props.theme === 'vs-dark' ? '#1e1e1e' : '#fff',
          padding: '40px 8px',
        }}
      >
        <CodeResetButton
          theme={this.props.theme}
          codeReset={this.props.codeReset}
        />
        <RunCodeButton
          theme={this.props.theme}
          disabled={this.props.disabled}
          submitCode={this.props.submitCode}
        />
      </div>
    );
  }
}

export default Footer;
